module.exports = require("regenerator-runtime");



//////////////////
// WEBPACK FOOTER
// ./~/.store/babel-runtime@6.26.0/~/babel-runtime/regenerator/index.js
// module id = 536
// module chunks = 75